import { AccountLayout } from "../AccountLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountEntities } from "../AccountEntities";

export interface SessionListPageProps extends NSARouterMakerResult, AccountRouterProps
{ }

export default function SessionListPage(props: SessionListPageProps) 
{
    return (
        <AccountLayout {...props}
            action={{
                title: '',
                description: 'View and manage your active account sessions to ensure your account is secure and accessible.',
                menus: {}
            }}
            pages={{
                entity: AccountEntities.session(props),
                ui: {
                    action: {
                        menus: {
                            view_history: false
                        }
                    }
                },
                list: {
                    ui: {
                        tab_page_view: {
                            tabs: {
                                history: false
                            }
                        }
                    }
                },
            }}
        >
            <></>
        </AccountLayout>
    );
};